import metrikaId from './metrika';

export default function metrikaGoal(goalName, params = null) {
	if (window.location.host !== 'training.tedo.ru') {
		console.log('🎯 Fix metrika goal:', goalName, params);
	} else {
		// console.log('🎯 Fix metrika goal:', goalName, params);
		if (typeof ym === "function") {
			ym(metrikaId, 'reachGoal', goalName, params);
			// console.log('✅ Successfully sended', goalName);
		} else {
			// console.log('⚠️ Metrika is not initialised, waiting 200ms and try again', goalName);
			setTimeout(function(){
				metrikaGoal(goalName, params);
			}, 300);
		}
	}
}